import React, { Component } from 'react';
import { Button, Grid, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { SemanticUiColorOptions } from 'Common/Constants/SemanticUiColors';

import 'Styles/components/semantic-ui-color-picker.less';

export class SemanticUiColorPicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    color: PropTypes.string,
    reset: PropTypes.bool,
  };

  static defaultProps = {
    color: '',
    onChange: () => {},
    reset: true,
  };

  state = {
    isOpen: false,
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  close = () => {
    this.setState({ isOpen: false });
  };

  open = () => {
    this.setState({ isOpen: true });
  };

  handleChange = color => {
    this.props.onChange(color);
    this.close();
  };

  render() {
    const { color, reset, disabled } = this.props;

    const isSemanticColor =
      SemanticUiColorOptions.findIndex(c => c.value === color) > -1;

    return (
      <React.Fragment>
        <div className="color-picker">
          {color ? (
            <React.Fragment>
              <Button
                {...(isSemanticColor
                  ? { color }
                  : { style: { backgroundColor: color } })}
                icon="paint brush"
                onClick={() => !disabled && this.toggle()}
              />
              {reset && !disabled && (
                <Button
                  basic
                  icon="close"
                  onClick={() => this.handleChange('')}
                />
              )}
            </React.Fragment>
          ) : (
            <Button basic icon="paint brush" onClick={() => this.toggle()} />
          )}
          {this.state.isOpen && (
            <div className="popover">
              <div className="cover" onClick={this.close} />
              <Segment>
                <Grid columns="4" className="tight tight-y">
                  {SemanticUiColorOptions.map(c => (
                    <Grid.Column key={c.value}>
                      <Button
                        color={c.value}
                        onClick={() => this.handleChange(c.value)}
                        compact
                        fluid
                      >
                        {c.description}
                      </Button>
                    </Grid.Column>
                  ))}
                </Grid>
              </Segment>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SemanticUiColorPicker.js